(function init() {

	"use strict";

	/*
	 * helper functions to escape a string for safe output in HTML
	 * https://stackoverflow.com/a/7124052/2367550
	 */
	function encodeHTML (html) {
		return html.replace(/[&<>"'/]/g, function (match) {
			var htmlEscapes = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				"\"": "&quot;",
				"'": "&#39;",
				"/": "&#x2F;"
			};
			return htmlEscapes[match];
		});
	}

	var count, element, endpoint, offset, query;

	// get key and config from HTML
	element = document.querySelector(".bing");
	if (element) {
		count = parseInt(element.getAttribute("data-bing-custom-search-results-per-page"), 10) || 10;
	}
	endpoint = "https://wj6ny6uen5.execute-api.us-east-1.amazonaws.com/bing-custom-search";
	offset = 0;

	// use XMLHttpRequest
	function reqListener () {

		var data, size, index, results, page, matches, ol, sb_count;

		try {

			data = JSON.parse(this.responseText);
			if (data && data["_type"] === "SearchResponse") {

				results = document.getElementById("results");
				if (!data.webPages) {

					// no results
					results.innerHTML = "<ol id=\"b_results\" role=\"main\" \
					aria-label=\"Search Results\"><li class=\"b_no\" \
					data-bm=\"4\"><h1>There are no results for \
					<strong>" + encodeHTML(data.queryContext.originalQuery) + "</strong> \
					</h1><ul><li><span>Check your spelling or try different \
					keywords</span> </li></ul></li></ol>";
					return;

				}

				// add the number of results
				matches = data.webPages.totalEstimatedMatches || 0;
				if (matches > 1000) {

					// Bing seems to return some ludicrous result counts
					// and, at the same time, seems to top out at 1000 results
					// so, lets generate more reasonable number
					matches = matches % 1000 + 1000;

				}
				if (offset > 0) {
					offset = parseInt(offset, 10);
					count = parseInt(count, 10);
					var start = offset + 1;
					var end = offset + count;
					if (end > matches) {
						end = matches;
					}
					if (start > matches) {
						start = 1 + end - count;
					}
					sb_count = [
						start.toLocaleString() + "–",
						end.toLocaleString(),
						" of " + matches.toLocaleString()
					].join("");
				} else {
					sb_count = matches.toLocaleString();
				}
				results.innerHTML = "<div id=\"b_tween\">\
				<span class=\"sb_count\" data-bm=\"4\">" + sb_count + " \
				results</span></div>";

				// loop over results and display
				size = data.webPages.value.length || 0;
				if (size > 0) {

					ol = document.createElement("ol");
					ol.id = "b_results";
					ol.setAttribute("role", "main");
					ol.setAttribute("aria-label", "Search Results");
					results.appendChild(ol);

				}
				for (index = 0; index < size; index += 1) {

					page = data.webPages.value[index];

					// check for PDFs
					if (page.displayUrl.match(/\.pdf$/)) {
						page.isPDF = true;
					}
					ol.innerHTML += "<li class=\"b_algo\" data-bm=\"7\">\
					<div class=\"b_title\">\
					" + (page.isPDF ? "<span class=\"sb_doct_txt b_float\">[PDF]</span>" : "") + "\
					<h2 class=\"heading--4\">\
					<a class=\"q-link\" href=\"" + page.url + "\">\
					" + page.name + "\
					</a></h2></div><div class=\"b_caption\">\
					<div class=\"b_attribution\"><cite>\
					" + page.displayUrl + "\
					</cite></div><p>\
					" + encodeHTML(page.snippet) + "\
					</p></div></li>";

				}

				// attach pagination UI elements
				if (matches > count) {

					ol.appendChild(createPagination(matches));

				}

			} else {

				throw new Error("Unexpected response: " + this.responseText);

			}

		} catch (err) {

			throw err;

		}

	}

	function createPagination (matches) {

		var container, nav, h4, ul, li, a, div, pages, cpi, start, end;

		// calculate how many pages of results there are
		pages = Math.ceil(matches / count);

		// setup container
		container = document.createElement("li");
		container.className = "b_pag";
		container.setAttribute("data-bm", 17);

		// setup nav and heading
		nav = document.createElement("nav");
		nav.setAttribute("role", "navigation");
		container.appendChild(nav);
		h4 = document.createElement("h4");
		h4.innerHTML = "Pagination";
		h4.className = "b_hide";
		nav.appendChild(h4);

		// setup unordered list of pages avaiable
		ul = document.createElement("ul");
		ul.className = "sb_pagF";
		ul.setAttribute("aria-label", "More pages with results");
		nav.appendChild(ul);

		// calculate current page index and the start and end pages
		cpi = (offset / count) + 1;
		start = cpi - 2;
		if (start < 1) {
			start = 1;
		}
		end = start + 4;

		// generate up to 5 page links based on total estimated matches
		for (var i = start; i <= end; i += 1) {

			if (i <= pages) {

				li = document.createElement("li");
				a = document.createElement("a");
				a.innerHTML = i;
				if (i === cpi) {

					a.className = "sb_pagS";

				} else {

					a.setAttribute("aria-label", "Page " + i);
					a.href = "#page-" + i;
					a.addEventListener("click", handlePagination);

				}
				ul.appendChild(li.appendChild(a));

			}

		}

		// generate prev/next links
		if (start > 1) {

			li = document.createElement("li");
			a = document.createElement("a");
			a.className = "sb_pagP";
			a.title = "Previous page";
			a.href = "#prev";
			a.addEventListener("click", handlePagination);
			div = document.createElement("div");
			div.className = "sw_prev";
			div.innerHTML = "◄";
			a.appendChild(div);
			li.appendChild(a);
			ul.insertBefore(li, ul.childNodes[0]);

		}
		if (end < pages) {

			li = document.createElement("li");
			a = document.createElement("a");
			a.className = "sb_pagN";
			a.title = "Next page";
			a.href = "#next";
			a.addEventListener("click", handlePagination);
			div = document.createElement("div");
			div.className = "sw_next";
			div.innerHTML = "►";
			a.appendChild(div);
			li.appendChild(a);
			ul.appendChild(li);

		}

		return container;

	}

	// handle pageination
	function handlePagination (event) {

		var index;

		event.preventDefault();
		if (event.target.classList.contains("sw_prev")) {

			// previous page
			index = offset / count;

		} else if (event.target.classList.contains("sw_next")) {

			// next page
			index = (offset / count) + 2;

		} else {

			// page with index
			index = parseInt(event.target.innerText, 10);

		}
		offset = count * (index - 1);
		sendSearchRequest(query, offset);

	}

	function performGoogleSearch(query) {
		query = query.replace(/\s+/g, '+');
		var googleSearchURL = 'https://www.google.com/search?q=site%3Aqualys.com+' + query;
		window.location.href = googleSearchURL;
	}

	function sendSearchRequest (query, offset) {

		var req, results, url;

		// clear old results, if any
		results = document.getElementById("results");
		if (results) {

			results.innerHTML = "";

		}

		query = query || document.querySelector("input[name=query]").value;
		offset = offset || 0;
		req = new XMLHttpRequest();
		req.addEventListener("load", reqListener);
		url = [
			endpoint,
			"?query=" + encodeURIComponent(query),
			"&mkt=" + (navigator.language || "en-US"),
			"&count=" + encodeURIComponent(count),
			"&offset=" + encodeURIComponent(offset)
		].join("");
		//console.log("GET " + url);
		req.open("GET", url);
		req.send();

	}

	function handleSubmit (event) {

		var input;

		event.preventDefault();

		// get query string from input value
		input = event.target.querySelector("input[name=query]");
		if (input) {

			query = input.value;
			offset = 0;

		}

		// make request for new results
		// commented out as the bing search isn't working
		// sendSearchRequest(query, offset);
		performGoogleSearch(query);

	}

	// bind the form action to trigger the XMLHttpRequest
	var form = document.querySelector("#search_form");
	if (form) {

		form.addEventListener("submit", handleSubmit);

	}

	// look for a offset varialb ein the URL
	var match = location.search.match(/first=([0-9]+)([&;#]|$)/);
	if (match) {

		var first = parseInt(decodeURIComponent(match[1]), 10);
		if (first) {

			offset = first - 1;

		}

	}

	// look for a query variable in the URL
	match = location.search.match(/q=(.*?)([&;#]|$)/);
	if (match) {

		var q = decodeURIComponent(match[1]).replace(/\+/g, " ");
		if (q) {

			// update input value
			var input = document.querySelector("input[name=query]");
			if (input) {

				input.value = q;

			}

			// search for query
			sendSearchRequest(q, offset);

		}

	}

}());
